const Position = ({
  color = '#E9BF6E',
  width = 24,
  height = 24,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_235_19787)">
        <path
          d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
          fill={color}
        />
        <path d="M13 0H11V5H13V0Z" fill={color} />
        <path d="M24 11H19V13H24V11Z" fill={color} />
        <path d="M13 19H11V24H13V19Z" fill={color} />
        <path d="M5 11H0V13H5V11Z" fill={color} />
      </g>
      <defs>
        <clipPath id="clip0_235_19787">
          <rect width={width} height={height} fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Position;
